define(["require", "exports", "tslib", "mobx", "../model/entity/Facility", "../model/entity/PermitApplication", "../model/entity/PublicReport", "../model/entity/Sma", "../model/entity/SrCrApplication", "../model/entity/WaApplication", "../model/services/EventManager", "../model/services/SrmsServiceManager", "./Events", "./ModalStore"], function (require, exports, tslib_1, mobx_1, Facility_1, PermitApplication_1, PublicReport_1, Sma_1, SrCrApplication_1, WaApplication_1, EventManager_1, SrmsServiceManager_1, Events_1, ModalStore_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.EntityStore = void 0;
    var EntityUserAction;
    (function (EntityUserAction) {
        EntityUserAction[EntityUserAction["Save"] = 0] = "Save";
        EntityUserAction[EntityUserAction["Open"] = 1] = "Open";
        EntityUserAction[EntityUserAction["Close"] = 2] = "Close";
        EntityUserAction[EntityUserAction["Cancel"] = 3] = "Cancel";
    })(EntityUserAction || (EntityUserAction = {}));
    class EntityStore {
        get HasEntity() {
            return !!this.entity;
        }
        constructor(storeManager) {
            Object.defineProperty(this, "storeManager", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "entity", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "validation", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "isLoading", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: false
            });
            Object.defineProperty(this, "isSaving", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: false
            });
            Object.defineProperty(this, "childIdToRootIdMap", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: {}
            });
            (0, mobx_1.makeObservable)(this);
            this.storeManager = storeManager;
            EventManager_1.EventManager.Instance.on(Events_1.VALIDATION_CLEAR_EVENT, () => {
                this.resetValidation();
            });
            EventManager_1.EventManager.Instance.on(Events_1.USER_LOGGED_OUT_EVENT, () => {
                this.close(false);
            });
        }
        createTravelPermitApplication(geometry) {
            return new Promise((resolve, reject) => {
                this.create(SrmsServiceManager_1.SrmsServiceManager.Instance.PermitApplication.createTravelPermitApplication.bind(SrmsServiceManager_1.SrmsServiceManager.Instance.PermitApplication), geometry)
                    .then(res => {
                    this.entity = new PermitApplication_1.PermitApplication(res);
                    resolve(this.entity);
                })
                    .catch(err => {
                    reject(err);
                });
            });
        }
        createGrazingPermitApplication(geometry) {
            return new Promise((resolve, reject) => {
                this.create(SrmsServiceManager_1.SrmsServiceManager.Instance.PermitApplication.createGrazingPermitApplication.bind(SrmsServiceManager_1.SrmsServiceManager.Instance.PermitApplication), geometry)
                    .then(res => {
                    this.entity = new PermitApplication_1.PermitApplication(res);
                    resolve(this.entity);
                })
                    .catch(err => {
                    reject(err);
                });
            });
        }
        createHarvestingPermitApplication(geometry) {
            return new Promise((resolve, reject) => {
                this.create(SrmsServiceManager_1.SrmsServiceManager.Instance.PermitApplication.createHarvestingPermitApplication.bind(SrmsServiceManager_1.SrmsServiceManager.Instance.PermitApplication), geometry)
                    .then(res => {
                    this.entity = new PermitApplication_1.PermitApplication(res);
                    resolve(this.entity);
                })
                    .catch(err => {
                    reject(err);
                });
            });
        }
        createGrazingAuthorityPermitApplication(geometry) {
            return new Promise((resolve, reject) => {
                this.create(SrmsServiceManager_1.SrmsServiceManager.Instance.PermitApplication.createGrazingAuthorityPermitApplication.bind(SrmsServiceManager_1.SrmsServiceManager.Instance.PermitApplication), geometry)
                    .then(res => {
                    this.entity = new PermitApplication_1.PermitApplication(res);
                    resolve(this.entity);
                })
                    .catch(err => {
                    reject(err);
                });
            });
        }
        createFacility(geometry) {
            return new Promise((resolve, reject) => {
                this.create(SrmsServiceManager_1.SrmsServiceManager.Instance.Facility.createFacility.bind(SrmsServiceManager_1.SrmsServiceManager.Instance.Facility), geometry)
                    .then(res => {
                    this.entity = new Facility_1.Facility(res);
                    resolve(this.entity);
                })
                    .catch(err => {
                    reject(err);
                });
            });
        }
        createWaApplication(agreementType, facility) {
            console.log(facility);
            return new Promise((resolve, reject) => {
                this.create(SrmsServiceManager_1.SrmsServiceManager.Instance.WaterAgreementApplication.createWaterAgreementApplicationByWf.bind(SrmsServiceManager_1.SrmsServiceManager.Instance.WaterAgreementApplication), agreementType, facility)
                    .then(res => {
                    this.entity = new WaApplication_1.WaApplication(res);
                    this.entity.SelectedWa = this.entity.Wa[0];
                    this.entity.SelectedWa.SelectedWaWaterFacility = this.entity.SelectedWa.WaWaterFacility[0];
                    resolve(this.entity);
                })
                    .catch(err => {
                    reject(err);
                });
            });
        }
        createWaApplicationByParcel(agreementType, parcel) {
            console.log(parcel);
            return new Promise((resolve, reject) => {
                this.create(SrmsServiceManager_1.SrmsServiceManager.Instance.WaterAgreementApplication.createWaterAgreementApplicationByParcel.bind(SrmsServiceManager_1.SrmsServiceManager.Instance.WaterAgreementApplication), agreementType, parcel)
                    .then(res => {
                    this.entity = new WaApplication_1.WaApplication(res);
                    this.entity.SelectedWa = this.entity.Wa[0];
                    resolve(this.entity);
                })
                    .catch(err => {
                    reject(err);
                });
            });
        }
        createScrApplication(changeType, parcels) {
            return new Promise((resolve, reject) => {
                this.create(SrmsServiceManager_1.SrmsServiceManager.Instance.StockRouteNetworkManagement.createSrCrApplication.bind(SrmsServiceManager_1.SrmsServiceManager.Instance.StockRouteNetworkManagement), changeType, parcels)
                    .then(res => {
                    this.entity = new SrCrApplication_1.SrCrApplication(res);
                    this.entity.SelectedSrCr = this.entity.SrCr[0];
                    resolve(this.entity);
                })
                    .catch(err => {
                    reject(err);
                });
            });
        }
        createSma(geometry) {
            return new Promise((resolve, reject) => {
                this.create(SrmsServiceManager_1.SrmsServiceManager.Instance.Sma.createSpecialManagementArea.bind(SrmsServiceManager_1.SrmsServiceManager.Instance.Sma), geometry)
                    .then(res => {
                    this.entity = new Sma_1.Sma(res);
                    resolve(this.entity);
                })
                    .catch(err => {
                    reject(err);
                });
            });
        }
        createPublicReport(geometry) {
            return new Promise((resolve, reject) => {
                this.create(SrmsServiceManager_1.SrmsServiceManager.Instance.PublicReport.createPublicReport.bind(SrmsServiceManager_1.SrmsServiceManager.Instance.PublicReport), geometry)
                    .then(res => {
                    this.entity = new PublicReport_1.PublicReport(res);
                    resolve(this.entity);
                })
                    .catch(err => {
                    reject(err);
                });
            });
        }
        openPermitApplication(entityId) {
            return new Promise((resolve, reject) => {
                entityId = ensureInt(entityId);
                this.open(SrmsServiceManager_1.SrmsServiceManager.Instance.PermitApplication.readPermitApplication.bind(SrmsServiceManager_1.SrmsServiceManager.Instance.PermitApplication), entityId)
                    .then(res => {
                    if (res) {
                        (0, mobx_1.runInAction)(() => {
                            this.entity = new PermitApplication_1.PermitApplication(res);
                            this.entity.SelectedPermit = this.entity.Permit.find(x => x.IsActive);
                        });
                    }
                    resolve(this.entity);
                })
                    .catch(err => {
                    reject(err);
                });
            });
        }
        openPermitApplicationByPermit(entityId) {
            return new Promise((resolve, reject) => {
                entityId = ensureInt(entityId);
                this.open(SrmsServiceManager_1.SrmsServiceManager.Instance.PermitApplication.readPermitApplicationByPermitId.bind(SrmsServiceManager_1.SrmsServiceManager.Instance.PermitApplication), entityId)
                    .then(res => {
                    if (res) {
                        (0, mobx_1.runInAction)(() => {
                            this.entity = new PermitApplication_1.PermitApplication(res);
                            this.childIdToRootIdMap[entityId] = this.entity.Id;
                            this.entity.SelectedPermit = this.entity.Permit.find(x => x.Id === entityId);
                        });
                    }
                    resolve(this.entity);
                })
                    .catch(err => {
                    reject(err);
                });
            });
        }
        openFacility(entityId) {
            return new Promise((resolve, reject) => {
                entityId = ensureInt(entityId);
                this.open(SrmsServiceManager_1.SrmsServiceManager.Instance.Facility.readFacility.bind(SrmsServiceManager_1.SrmsServiceManager.Instance.Facility), entityId)
                    .then(res => {
                    if (res) {
                        this.entity = new Facility_1.Facility(res);
                    }
                    resolve(this.entity);
                })
                    .catch(err => {
                    reject(err);
                });
            });
        }
        openFacilityWorksProject(entityId) {
            return new Promise((resolve, reject) => {
                entityId = ensureInt(entityId);
                this.open(SrmsServiceManager_1.SrmsServiceManager.Instance.Facility.readFacilityByWorksProject.bind(SrmsServiceManager_1.SrmsServiceManager.Instance.Facility), entityId)
                    .then(res => {
                    if (res) {
                        this.entity = new Facility_1.Facility(res);
                        this.childIdToRootIdMap[entityId] = this.entity.Id;
                        this.entity.SelectedFWorksProject = this.entity.FWorksProject.find(x => x.Id === entityId);
                    }
                    resolve(this.entity);
                })
                    .catch(err => {
                    reject(err);
                });
            });
        }
        openFacilityInspection(entityId) {
            return new Promise((resolve, reject) => {
                entityId = ensureInt(entityId);
                this.open(SrmsServiceManager_1.SrmsServiceManager.Instance.Facility.readFacilityByInspection.bind(SrmsServiceManager_1.SrmsServiceManager.Instance.Facility), entityId)
                    .then(res => {
                    if (res) {
                        this.entity = new Facility_1.Facility(res);
                        this.childIdToRootIdMap[entityId] = this.entity.Id;
                        this.entity.SelectedFInspection = this.entity.FInspection.find(x => x.Id === entityId);
                    }
                    resolve(this.entity);
                })
                    .catch(err => {
                    reject(err);
                });
            });
        }
        openWaApplication(entityId) {
            return new Promise((resolve, reject) => {
                entityId = ensureInt(entityId);
                this.open(SrmsServiceManager_1.SrmsServiceManager.Instance.WaterAgreementApplication.readWaterAgreementApplication.bind(SrmsServiceManager_1.SrmsServiceManager.Instance.WaterAgreementApplication), entityId)
                    .then(res => {
                    if (res) {
                        this.entity = new WaApplication_1.WaApplication(res);
                        this.entity.SelectedWa = this.entity.Wa.find(x => x.IsActive);
                        if (this.entity.SelectedWa &&
                            this.entity.SelectedWa.WaWaterFacility.length > 0) {
                            this.entity.SelectedWa.SelectedWaWaterFacility = this.entity.SelectedWa.WaWaterFacility[0];
                        }
                        if (this.entity.SelectedWa &&
                            this.entity.SelectedWa.WaLandowner.length > 0) {
                            this.entity.SelectedWa.SelectedWaLandowner = this.entity.SelectedWa.WaLandowner[0];
                        }
                    }
                    resolve(this.entity);
                })
                    .catch(err => {
                    reject(err);
                });
            });
        }
        openWaApplicationAgreement(entityId) {
            return new Promise((resolve, reject) => {
                entityId = ensureInt(entityId);
                this.open(SrmsServiceManager_1.SrmsServiceManager.Instance.WaterAgreementApplication.readWaterAgreementApplicationByAgreementId.bind(SrmsServiceManager_1.SrmsServiceManager.Instance.WaterAgreementApplication), entityId)
                    .then(res => {
                    if (res) {
                        this.entity = new WaApplication_1.WaApplication(res);
                        this.childIdToRootIdMap[entityId] = this.entity.Id;
                        this.entity.SelectedWa = this.entity.Wa.find(x => x.Id === entityId);
                        if (this.entity.SelectedWa) {
                            if (this.entity.SelectedWa.WaWaterFacility.length > 0) {
                                this.entity.SelectedWa.SelectedWaWaterFacility = this.entity.SelectedWa.WaWaterFacility[0];
                            }
                            if (this.entity.SelectedWa.WaLandowner.length > 0) {
                                this.entity.SelectedWa.SelectedWaLandowner = this.entity.SelectedWa.WaLandowner[0];
                            }
                        }
                    }
                    resolve(this.entity);
                })
                    .catch(err => {
                    reject(err);
                });
            });
        }
        openScrApplication(entityId) {
            return new Promise((resolve, reject) => {
                entityId = ensureInt(entityId);
                this.open(SrmsServiceManager_1.SrmsServiceManager.Instance.StockRouteNetworkManagement.readSrCrApplication.bind(SrmsServiceManager_1.SrmsServiceManager.Instance.StockRouteNetworkManagement), entityId, true)
                    .then(res => {
                    if (res) {
                        this.entity = new SrCrApplication_1.SrCrApplication(res);
                    }
                    resolve(this.entity);
                })
                    .catch(err => {
                    reject(err);
                });
            });
        }
        openScrApplicationByCrId(entityId) {
            return new Promise((resolve, reject) => {
                entityId = ensureInt(entityId);
                this.open(SrmsServiceManager_1.SrmsServiceManager.Instance.StockRouteNetworkManagement.readSrCrApplicationByCrId.bind(SrmsServiceManager_1.SrmsServiceManager.Instance.StockRouteNetworkManagement), entityId, true)
                    .then(res => {
                    if (res) {
                        this.entity = new SrCrApplication_1.SrCrApplication(res);
                        this.childIdToRootIdMap[entityId] = this.entity.Id;
                        this.entity.SelectedSrCr = this.entity.SrCr.find(x => x.Id === entityId);
                    }
                    resolve(this.entity);
                })
                    .catch(err => {
                    reject(err);
                });
            });
        }
        openSma(entityId) {
            return new Promise((resolve, reject) => {
                entityId = ensureInt(entityId);
                this.open(SrmsServiceManager_1.SrmsServiceManager.Instance.Sma.readSpecialManagementArea.bind(SrmsServiceManager_1.SrmsServiceManager.Instance.Sma), entityId)
                    .then(res => {
                    if (res) {
                        this.entity = new Sma_1.Sma(res);
                    }
                    resolve(this.entity);
                })
                    .catch(err => {
                    reject(err);
                });
            });
        }
        openPublicReport(entityId) {
            return new Promise((resolve, reject) => {
                entityId = ensureInt(entityId);
                this.open(SrmsServiceManager_1.SrmsServiceManager.Instance.PublicReport.readPublicReport.bind(SrmsServiceManager_1.SrmsServiceManager.Instance.PublicReport), entityId)
                    .then(res => {
                    if (res) {
                        this.entity = new PublicReport_1.PublicReport(res);
                    }
                    resolve(this.entity);
                })
                    .catch(err => {
                    reject(err);
                });
            });
        }
        isEntityLoaded(entityId) {
            return this.entity && (this.entity.Id == entityId || this.childIdToRootIdMap[entityId] == this.entity.Id);
        }
        save() {
            return new Promise((resolve, reject) => {
                if (!this.HasEntity) {
                    throw new Error("Entity not loaded");
                }
                (0, EventManager_1.notify)("Saving..");
                this.isSaving = true;
                this.validation = this.entity.validate();
                if (!this.validation.HasErrors) {
                    let saveApi;
                    let refreshMap = false;
                    if (this.entity instanceof PermitApplication_1.PermitApplication) {
                        saveApi = SrmsServiceManager_1.SrmsServiceManager.Instance.PermitApplication.persistPermitApplication.bind(SrmsServiceManager_1.SrmsServiceManager.Instance.PermitApplication);
                    }
                    else if (this.entity instanceof Facility_1.Facility) {
                        saveApi = SrmsServiceManager_1.SrmsServiceManager.Instance.Facility.persistFacility.bind(SrmsServiceManager_1.SrmsServiceManager.Instance.Facility);
                    }
                    else if (this.entity instanceof WaApplication_1.WaApplication) {
                        saveApi = SrmsServiceManager_1.SrmsServiceManager.Instance.WaterAgreementApplication.persistWaterAgreementApplication.bind(SrmsServiceManager_1.SrmsServiceManager.Instance.WaterAgreementApplication);
                    }
                    else if (this.entity instanceof SrCrApplication_1.SrCrApplication) {
                        saveApi = SrmsServiceManager_1.SrmsServiceManager.Instance.StockRouteNetworkManagement.persistSrCrApplication.bind(SrmsServiceManager_1.SrmsServiceManager.Instance.StockRouteNetworkManagement);
                    }
                    else if (this.entity instanceof Sma_1.Sma) {
                        saveApi = SrmsServiceManager_1.SrmsServiceManager.Instance.Sma.persistSpecialManagementArea.bind(SrmsServiceManager_1.SrmsServiceManager.Instance.Sma);
                    }
                    else if (this.entity instanceof PublicReport_1.PublicReport) {
                        saveApi = SrmsServiceManager_1.SrmsServiceManager.Instance.PublicReport.persistPublicReport.bind(SrmsServiceManager_1.SrmsServiceManager.Instance.PublicReport);
                    }
                    else {
                        throw new Error("Unsupported Entity type");
                    }
                    saveApi(this.entity.toJson())
                        .then(res => {
                        (0, mobx_1.runInAction)(() => {
                            this.isSaving = false;
                            if (this.entity instanceof PermitApplication_1.PermitApplication) {
                                const result = res;
                                this.validation.addEntityCollectionValidationResult(this.entity, result.Validation);
                                if (result.IsSaveSuccessful) {
                                    this.entity.disableChangeObserver();
                                    this.entity.merge(result.Application);
                                    this.entity.enableChangeObserver();
                                }
                                else {
                                    throw new Error();
                                }
                            }
                            else if (this.entity instanceof Facility_1.Facility) {
                                const result = res;
                                this.validation.addEntityCollectionValidationResult(this.entity, result.Validation);
                                if (result.IsSaveSuccessful) {
                                    this.entity.disableChangeObserver();
                                    this.entity.merge(result.Facility);
                                    this.entity.enableChangeObserver();
                                }
                                else {
                                    throw new Error();
                                }
                            }
                            else if (this.entity instanceof WaApplication_1.WaApplication) {
                                const result = res;
                                this.validation.addEntityCollectionValidationResult(this.entity, result.Validation);
                                if (result.IsSaveSuccessful) {
                                    this.entity.disableChangeObserver();
                                    this.entity.merge(result.Application);
                                    this.entity.enableChangeObserver();
                                }
                                else {
                                    throw new Error();
                                }
                            }
                            else if (this.entity instanceof SrCrApplication_1.SrCrApplication) {
                                const result = res;
                                this.validation.addEntityCollectionValidationResult(this.entity, result.Validation);
                                if (result.IsSaveSuccessful) {
                                    refreshMap = true;
                                    this.entity.disableChangeObserver();
                                    this.entity.merge(result.Application);
                                    this.entity.enableChangeObserver();
                                }
                                else {
                                    throw new Error();
                                }
                            }
                            else if (this.entity instanceof Sma_1.Sma) {
                                const result = res;
                                this.validation.addValidationResult(result.Validation);
                                if (result.IsSaveSuccessful) {
                                    this.entity.disableChangeObserver();
                                    this.entity.merge(result.Sma);
                                    this.entity.enableChangeObserver();
                                }
                                else {
                                    throw new Error();
                                }
                            }
                            else if (this.entity instanceof PublicReport_1.PublicReport) {
                                const result = res;
                                this.validation.addValidationResult(result.Validation);
                                if (result.IsSaveSuccessful) {
                                    this.entity.disableChangeObserver();
                                    this.entity.merge(result.PublicReport);
                                    this.entity.enableChangeObserver();
                                }
                                else {
                                    throw new Error();
                                }
                            }
                            else {
                                throw new Error("Not implemented");
                            }
                            if (this.validation.HasMessages) {
                                EventManager_1.EventManager.Instance.emit(Events_1.VALIDATION_UPDATE_EVENT, this.validation);
                            }
                            if (refreshMap) {
                                EventManager_1.EventManager.Instance.emit(Events_1.MAP_REFRESH_EVENT);
                            }
                            resolve(this.entity);
                        });
                    })
                        .catch(err => {
                        console.log("Save error", err);
                        this.isSaving = false;
                        if (this.validation.HasMessages) {
                            EventManager_1.EventManager.Instance.emit(Events_1.VALIDATION_UPDATE_EVENT, this.validation);
                        }
                        reject(err);
                    });
                }
                else {
                    (0, EventManager_1.notify)(`Save Failed. Errors found`);
                    this.isSaving = false;
                    if (this.validation.HasMessages) {
                        EventManager_1.EventManager.Instance.emit(Events_1.VALIDATION_UPDATE_EVENT, this.validation);
                    }
                    reject();
                }
            });
        }
        close(saveChanges = true) {
            return new Promise((resolve, reject) => {
                if (!this.HasEntity) {
                    return resolve(true);
                }
                if (saveChanges && this.entity.hasChanges()) {
                    this.askUserToSaveOrDiscardChanges()
                        .then((type) => {
                        if (type == EntityUserAction.Save) {
                            this.save()
                                .then(res => {
                                this._close()
                                    .then(() => {
                                    resolve(true);
                                })
                                    .catch(err => {
                                    reject(err);
                                });
                            })
                                .catch(err => {
                                reject(err);
                            });
                        }
                        else if (type == EntityUserAction.Close) {
                            this._close()
                                .then(() => {
                                resolve(true);
                            })
                                .catch(err => {
                                reject(err);
                            });
                        }
                        else {
                            resolve(false);
                        }
                    })
                        .catch(err => {
                        reject(err);
                    });
                }
                else {
                    this._close()
                        .then(() => {
                        resolve(true);
                    })
                        .catch(err => {
                        reject(err);
                    });
                }
            });
        }
        askUserToConfirmChange() {
            return new Promise((resolve, reject) => {
                const p = {};
                p.title = `Close ${this.entity.RefId}?`;
                p.msg = `${this.entity.RefId} is presently open. Do you wish to close it and then open the requested Task/Application? `;
                p.enableYes = true;
                p.enableNo = true;
                p.enableCancel = false;
                this.storeManager.modalStore
                    .createYesNoCancelModal(p)
                    .then((res) => {
                    if (res == ModalStore_1.ModalResponse.Yes) {
                        resolve(EntityUserAction.Open);
                    }
                    else {
                        resolve(EntityUserAction.Cancel);
                    }
                })
                    .catch(err => {
                    resolve(EntityUserAction.Cancel);
                });
            });
        }
        askUserToSaveOrDiscardChanges() {
            return new Promise((resolve, reject) => {
                const p = {};
                p.title = "Save changes?";
                p.msg = `${this.entity.RefId} has unsaved changes. Do you wish to save your changes? `;
                p.enableYes = true;
                p.enableNo = true;
                p.enableCancel = true;
                p.yesLabel = "Save";
                p.noLabel = "Discard";
                this.storeManager.modalStore
                    .createYesNoCancelModal(p)
                    .then((res) => {
                    if (res == ModalStore_1.ModalResponse.No) {
                        resolve(EntityUserAction.Close);
                    }
                    else if (res == ModalStore_1.ModalResponse.Yes) {
                        resolve(EntityUserAction.Save);
                    }
                    else {
                        resolve(EntityUserAction.Cancel);
                    }
                })
                    .catch(err => {
                    resolve(EntityUserAction.Cancel);
                });
            });
        }
        resetValidation() {
            if (this.validation) {
                this.validation = null;
            }
        }
        create(action, ...args) {
            return new Promise((resolve, reject) => {
                if (this.HasEntity) {
                    this.askUserToSaveOrDiscardChanges()
                        .then((type) => {
                        if (type == EntityUserAction.Save) {
                            this.save()
                                .then((res) => {
                                this.close(false)
                                    .then(() => {
                                    this._create(action, ...args)
                                        .then((res) => {
                                        resolve(res);
                                    })
                                        .catch(err => {
                                        reject(err);
                                    });
                                })
                                    .catch(err => {
                                    reject(err);
                                });
                            })
                                .catch(err => {
                                reject(err);
                            });
                        }
                        else if (type == EntityUserAction.Close) {
                            this.close(false)
                                .then(() => {
                                this._create(action, ...args)
                                    .then((res) => {
                                    resolve(res);
                                })
                                    .catch(err => {
                                    reject(err);
                                });
                            })
                                .catch(err => {
                                reject(err);
                            });
                        }
                        else if (type == EntityUserAction.Cancel) {
                            resolve(undefined);
                        }
                        else {
                            throw new Error("Unsupported Entity action");
                        }
                    })
                        .catch(err => {
                        reject(err);
                    });
                }
                else {
                    this._create(action, ...args)
                        .then((res) => {
                        resolve(res);
                    })
                        .catch(err => {
                        reject(err);
                    });
                }
            });
        }
        _create(action, ...args) {
            return new Promise((resolve, reject) => {
                (0, EventManager_1.notify)("Creating..");
                this.isLoading = true;
                EventManager_1.EventManager.Instance.emit(Events_1.ENTITY_CREATE_EVENT);
                action(...args)
                    .then((res) => {
                    resolve(res);
                    this.isLoading = false;
                    EventManager_1.EventManager.Instance.emit(Events_1.ENTITY_CREATED_EVENT, res.Id);
                })
                    .catch(err => {
                    this.isLoading = false;
                    EventManager_1.EventManager.Instance.emit(Events_1.ENTITY_CREATE_ERROR_EVENT, null, err);
                    reject(err);
                });
            });
        }
        open(action, entityId, ...args) {
            if (typeof entityId === "string") {
                entityId = parseInt(entityId);
            }
            return new Promise((resolve, reject) => {
                if (this.HasEntity) {
                    if (!this.isEntityLoaded(entityId)) {
                        if (this.entity.hasChanges()) {
                            this.askUserToSaveOrDiscardChanges()
                                .then((type) => {
                                if (type == EntityUserAction.Save) {
                                    this.save()
                                        .then((res) => {
                                        this._open(action, entityId, ...args)
                                            .then((res) => {
                                            resolve(res);
                                        })
                                            .catch(err => {
                                            reject(err);
                                        });
                                    })
                                        .catch(err => {
                                        reject(err);
                                    });
                                }
                                else if (type == EntityUserAction.Close) {
                                    this.close(false)
                                        .then(() => {
                                        this._open(action, entityId, ...args)
                                            .then((res) => {
                                            resolve(res);
                                        })
                                            .catch(err => {
                                            reject(err);
                                        });
                                    })
                                        .catch(err => {
                                        reject(err);
                                    });
                                }
                                else if (type == EntityUserAction.Cancel) {
                                    resolve(undefined);
                                }
                                else {
                                    throw new Error("Unsupported Entity action");
                                }
                            })
                                .catch(err => {
                                reject(err);
                            });
                        }
                        else {
                            this.askUserToConfirmChange().then((type) => {
                                if (type == EntityUserAction.Open) {
                                    this._open(action, entityId, ...args)
                                        .then((res) => {
                                        resolve(res);
                                    })
                                        .catch(err => {
                                        reject(err);
                                    });
                                }
                                else if (type == EntityUserAction.Cancel) {
                                    resolve(undefined);
                                }
                                else {
                                    throw new Error("Unsupported Entity action");
                                }
                            });
                        }
                    }
                    else {
                        resolve(undefined);
                    }
                }
                else {
                    this._open(action, entityId, ...args)
                        .then((res) => {
                        resolve(res);
                    })
                        .catch(err => {
                        reject(err);
                    });
                }
            });
        }
        _open(action, entityId, ...args) {
            return new Promise((resolve, reject) => {
                (0, EventManager_1.notify)("Opening..");
                this.isLoading = true;
                EventManager_1.EventManager.Instance.emit(Events_1.ENTITY_OPEN_EVENT, entityId);
                action(entityId, ...args)
                    .then((res) => {
                    resolve(res);
                    this.isLoading = false;
                    EventManager_1.EventManager.Instance.emit(Events_1.ENTITY_OPENED_EVENT, entityId);
                })
                    .catch(err => {
                    this.isLoading = false;
                    EventManager_1.EventManager.Instance.emit(Events_1.ENTITY_OPEN_ERROR_EVENT, entityId, err);
                    reject(err);
                });
            });
        }
        _close() {
            return new Promise((resolve, reject) => {
                const entityId = this.entity.Id;
                try {
                    EventManager_1.EventManager.Instance.emit(Events_1.ENTITY_CLOSE_EVENT, entityId);
                    (0, mobx_1.runInAction)(() => {
                        this.childIdToRootIdMap = {};
                        this.resetValidation();
                        this.entity.dispose();
                        this.entity = null;
                        resolve();
                        EventManager_1.EventManager.Instance.emit(Events_1.ENTITY_CLOSED_EVENT, entityId);
                    });
                }
                catch (err) {
                    EventManager_1.EventManager.Instance.emit(Events_1.ENTITY_CLOSE_ERROR_EVENT, entityId, err);
                    reject(err);
                }
            });
        }
    }
    exports.EntityStore = EntityStore;
    tslib_1.__decorate([
        mobx_1.observable
    ], EntityStore.prototype, "entity", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], EntityStore.prototype, "validation", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], EntityStore.prototype, "isLoading", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], EntityStore.prototype, "isSaving", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], EntityStore.prototype, "close", null);
    tslib_1.__decorate([
        mobx_1.action
    ], EntityStore.prototype, "resetValidation", null);
    tslib_1.__decorate([
        mobx_1.action
    ], EntityStore.prototype, "_create", null);
    tslib_1.__decorate([
        mobx_1.action
    ], EntityStore.prototype, "_open", null);
    tslib_1.__decorate([
        mobx_1.action
    ], EntityStore.prototype, "_close", null);
    function ensureInt(x) {
        return typeof x == "string" ? parseInt(x) : x;
    }
});
